import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import {
  Table,
  Button,
  Modal,
  Input,
  notification,
  Select,
  Popconfirm,
  Tag,
  Space,
  Spin,
} from "antd";
import { SmileOutlined, SearchOutlined } from "@ant-design/icons";
import Tooltip from "@mui/material/Tooltip";
import { decryptRequest } from "../../utils/crypt";
import { getUsersList, editUser, deletUser } from "../../services/User";
import { FilterForCamera } from "../../services/Filters";
import AlertNotification from "../../common/Alert/AlertNotification";

//React Icons
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { CgCalendarDates } from "react-icons/cg";
import { FaUniversalAccess } from "react-icons/fa";
import { ImLocation2 } from "react-icons/im";
import { FaEdit } from "react-icons/fa";

const openNotification = (description) => {
  notification.open({
    message: "Alert",
    description,
    icon: (
      <SmileOutlined
        style={{
          color: "black",
        }}
      />
    ),
  });
};

function UsersTable(props) {
  const {
    apiData: { data },
    addClick,
  } = props;
  let [isDeleteClicked, setIsDeleteClicked] = useState(false);
  let [userTable, setUserTable] = useState([]);
  const [accessValue, setAccessValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestedEmail, setRequestedEmail] = useState("");
  const [accessValueForNewUser, setAccessValuForNewUser] = useState(null);
  const [newUserName, setNewUserName] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [locations, setLocations] = useState(null);
  const [locationsSelected, setLocationsSelected] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const navigate = useNavigate();

  //Modal Function
  const showModal = (record) => {
    let locationType = record.locationAccess
      .map((item) => item.locationType)
      .filter((item, index, self) => self.indexOf(item) === index);
    setIsModalOpen(true);
    setRequestedEmail(record._id);
    setNewUserEmail(record.email);
    setNewUserName(record.name);
    setAccessValuForNewUser(accessValue);
    if (locationType?.length == 1) {
      setLocationsSelected(locationType);
    } else {
      setLocationsSelected("Display All");
    }
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleNameChange = (e) => {
    setNewUserName(e.target.value);
  };
  const handleEmailChange = (e) => {
    setNewUserEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setNewUserPassword(e.target.value);
  };

  const handleAccessChange = (value) => {
    setAccessValuForNewUser(value);
  };
  const handleLocationsChange = (value) => {
    setLocationsSelected(value);
  };

  function validateEmail(email) {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  }

  function validateName(name) {
    const nameRegex = /^[a-zA-Z\s'-]+$/;
    return nameRegex.test(name);
  }

  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: 10, // Number of rows per page
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50"],
    totalPages: 0,
    totalUsers: 0,
  });

  const handleTableChange = (pagination) => {
    setTablePagination({
      ...pagination,
      current: pagination.current,
    });
  };
  // const handleTableChange = (pagination) => {
  //   console.log("Pagination Change:", pagination); // Log to see what is passed
  //   setTablePagination({
  //     current: pagination.current,
  //     pageSize: pagination.pageSize,
  //     showSizeChanger: true,
  //     pageSizeOptions: ["5", "10", "20", "50"],
  //     totalPages: tablePagination.totalPages, // Ensure this is correct
  //   });
  // };

  let getUserDataList = async () => {
    console.log("Into function call ----> ", tablePagination);
    let Userdata = await getUsersList({
      current: tablePagination.current,
      pageSize: tablePagination.pageSize,
    });
    console.log("User Data ---> ", Userdata);
    let { pagination } = Userdata.data;
    setTablePagination({
      ...tablePagination,
      current: pagination.currentPage,
      totalUsers: pagination.totalUsers,
      totalPages: pagination.totalPages,
    });
    setUserTable(Userdata?.data.data);
  };
  const getFiltersData = async () => {
    let camerasList = await FilterForCamera();
    if (camerasList == 400) {
      localStorage.clear();
      navigate("/");
    } else if (camerasList?.locationNames?.length > 0) {
      setLocations(camerasList?.locationNames);
    }
  };

  useEffect(() => {
    getFiltersData();
    let token = localStorage.getItem("token");
    var decoded = jwt_decode(token);
    let { encryptedData } = decoded;
    decryptRequest(encryptedData).then((res) => {
      let { userType } = JSON.parse(res).data;
      setAccessValue(userType);
    });
  }, []);

  const handleEditUser = async () => {
    let emailValidation = validateEmail(newUserEmail);
    let nameValidation = validateName(newUserName);
    if (!emailValidation) {
      setError(true);
      setErrorMessage("Enter a valid email");
    } else if (!nameValidation) {
      setError(true);
      setErrorMessage("Enter a valid name");
    } else {
      let editUserResponse = await editUser({
        requestedEmail,
        newUserName,
        newUserEmail,
        accessValueForNewUser,
        locationsSelected,
      });
      if (editUserResponse) {
        setSuccess(true);
        setSuccessMessage("User updated successfully");
        getUserDataList();
        handleModalClose();
        setNewUserEmail("");
        setNewUserName("");
        setNewUserPassword("");
        setAccessValuForNewUser(null);
        setLocationsSelected(null);
      } else {
        openNotification(editUserResponse);
        handleModalClose();
        setNewUserEmail("");
        setNewUserName("");
        setNewUserPassword("");
        setAccessValuForNewUser("");
        setLocationsSelected("");
      }
    }
  };

  const handleDelete = async (record) => {
    setIsDeleteClicked(true);
    let deleteUserResponse = await deletUser({ email: record._id });
    if (deleteUserResponse) {
      setSuccess(true);
      setSuccessMessage("User Deleted Successfully");
      getUserDataList();
    }
  };
  useEffect(() => {
    if (tablePagination.current && tablePagination.pageSize) {
      getUserDataList();
    }
  }, [tablePagination.current, tablePagination.pageSize]);
  useEffect(() => {
    if (!isDeleteClicked) {
      getUserDataList();
    } else if (addClick) {
      getUserDataList();
    } else {
      getUserDataList();
    }
  }, [isDeleteClicked, addClick]);

  const handleResetPassword = () => {
    navigate("/forgotpassword");
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    getUserDataList();
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters()}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
  });

  const columns = [
    {
      title: (
        <div className="flex gap-2 items-center">
          <FaUserAlt className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Name
          </span>
        </div>
      ),
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name), // Enable sorting
      ...getColumnSearchProps("name"), // Enable searching
    },
    {
      title: (
        <div className="flex items-center gap-2">
          <MdOutlineMarkEmailUnread className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Email
          </span>
        </div>
      ),
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email), // Enable sorting
      ...getColumnSearchProps("email"), // Enable searching
    },
    {
      title: (
        <div className="flex items-center gap-2">
          <CgCalendarDates className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Date
          </span>
        </div>
      ),
      dataIndex: "lastLogin",
      sorter: (a, b) => new Date(a.lastLogin) - new Date(b.lastLogin), // Sorting by date
      ...getColumnSearchProps("lastLogin"), // Enable searching
    },
    {
      title: (
        <div className="flex items-center gap-2">
          <FaUniversalAccess className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Role
          </span>
        </div>
      ),
      dataIndex: "userType",
      sorter: (a, b) => a.userType.localeCompare(b.userType), // Enable sorting
      ...getColumnSearchProps("userType"), // Enable searching
    },
    {
      title: (
        <div className="flex gap-2 items-center">
          <ImLocation2 className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Location
          </span>
        </div>
      ),
      dataIndex: "location",
      render: (_, record) => {
        const uniqueLocationTypes = new Set();
        record.locationAccess?.forEach((location) => {
          uniqueLocationTypes.add(location.locationType);
        });
        return (
          <div style={{ textAlign: "center" }}>
            {uniqueLocationTypes.size > 0 ? (
              Array.from(uniqueLocationTypes).map((locationType) => {
                let color = "blue"; // Default color
                if (locationType.length > 10) {
                  color = "geekblue";
                }
                if (locationType === "Production") {
                  color = "volcano";
                }
                if (locationType === "Warehouse") {
                  color = "green";
                }
                return (
                  <Tag
                    color={color}
                    key={locationType}
                    style={{ display: "flex", marginBottom: "1vh" }}
                  >
                    {locationType.toUpperCase()}
                  </Tag>
                );
              })
            ) : (
              <span>No Locations</span>
            )}
          </div>
        );
      },
      ...getColumnSearchProps("location"), // Enable searching
    },
    {
      title: (
        <div className="flex gap-2 items-center">
          <FaEdit className="text-xl text-teal-700" />
          <span
            style={{
              color: "slategray",
              fontSize: "large",
              fontFamily: "Calibri",
              fontWeight: "normal",
            }}
          >
            Action
          </span>
        </div>
      ),
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "1vh" }}>
          <Tooltip
            title={
              accessValue == "Admin" || accessValue == "HSE"
                ? "Click Here To Edit This User"
                : "You Don't Have Permission For Edit."
            }
          >
            <Button
              className="bg-teal-700 text-white hover:bg-teal-600"
              disabled={accessValue !== "Admin" && accessValue !== "HSE"}
              onClick={() => {
                showModal(record);
              }}
            >
              Edit
            </Button>
          </Tooltip>
          <Popconfirm
            title="Delete"
            description="Are you sure to delete this user."
            onConfirm={() => handleDelete(record)}
            onCancel={() => {
              console.log("Delete No Clicked");
            }}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip
              title={
                accessValue == "Admin" || accessValue == "HSE"
                  ? "Click Here To Delete This User"
                  : "You Don't Have Permission For Delete."
              }
            >
              <Button
                disabled={accessValue !== "Admin" && accessValue !== "HSE"}
                className="bg-teal-700 text-white hover:bg-teal-600"
              >
                Delete
              </Button>
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
        }}
      >
        {success && (
          <div style={{ width: "40vh", height: "5vh" }}>
            <AlertNotification message={successMessage} status={true} />
          </div>
        )}
        {error && (
          <div style={{ width: "40vh", height: "5vh" }}>
            <AlertNotification message={errorMessage} status={false} />
          </div>
        )}
      </div>
      <div
        className="my-3"
        style={{ border: "1px solid #2292A4", borderRadius: "5px" }}
      >
        {tablePagination.current && tablePagination.pageSize ? (
          <Table
            columns={columns}
            dataSource={userTable}
            pagination={{
              current: tablePagination.current,
              pageSize: tablePagination.pageSize,
              total: tablePagination.totalUsers, // Total number of users
              onChange: (page, pageSize) =>
                handleTableChange({ current: page, pageSize }), // Handle page change
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50"], // Page size options
            }}
            rowKey="id" // Assuming each row has a unique 'id'
            // onChange={handleTableChange}
          />
        ) : (
          <Spin />
        )}
      </div>
      <>
        <Modal
          title="Edit User"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <div style={{ display: "flex", Gap: "2vh", flexDirection: "column" }}>
            <div style={{ padding: "1vh" }}>
              <Input
                placeholder="Name"
                value={newUserName}
                onChange={handleNameChange}
              />
            </div>
            <div style={{ padding: "1vh" }}>
              <Input
                placeholder="Email"
                value={newUserEmail}
                onChange={handleEmailChange}
              />
            </div>
            <div style={{ padding: "1vh", display: "flex", gap: "2vh" }}>
              <Select
                placeholder="Select User Type"
                defaultValue={accessValue}
                style={{
                  width: 200,
                }}
                value={accessValueForNewUser}
                onChange={handleAccessChange}
                options={[
                  {
                    value: "Admin",
                    label: "Admin",
                  },
                  {
                    value: "User",
                    label: "User",
                  },
                  {
                    value: "HSE",
                    label: "HSE",
                  },
                ]}
              />
              <Select
                placeholder="Select location type"
                style={{
                  width: 250,
                }}
                mode="multiple"
                value={locationsSelected || []}
                onChange={handleLocationsChange}
                options={[
                  { label: "Production", value: "Production" },
                  { label: "Warehouse", value: "Warehouse" },
                  { label: "Display All", value: "Display All" },
                ]}
              />
            </div>
            <div style={{ padding: "1vh" }}>
              <Button
                type="primary"
                onClick={handleResetPassword}
                className="bg-teal-700 text-white hover:bg-teal-600"
              >
                Reset Password
              </Button>
            </div>
            <div
              style={{
                padding: "1vh",
                gap: "1vh",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={handleEditUser}
                className="bg-teal-700 text-white hover:bg-teal-600"
              >
                Submit
              </Button>
              <Button
                onClick={handleModalClose}
                className="bg-teal-700 text-white hover:bg-teal-600"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      </>
    </>
  );
}

export default UsersTable;
